import { cbi_waste_container_frequency_period_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateCbiWasteContainerFrequencyPeriodEnum = (enumValue: cbi_waste_container_frequency_period_enum) => {
  switch (enumValue) {
    case cbi_waste_container_frequency_period_enum.BIWEEKLY:
      return <Trans i18nKey="Enum_CbiWasteContainerFrequencyPeriodEnum-BIWEEKLY" />;
    case cbi_waste_container_frequency_period_enum.DAILY:
      return <Trans i18nKey="Enum_CbiWasteContainerFrequencyPeriodEnum-DAILY" />;
    case cbi_waste_container_frequency_period_enum.MONTHLY:
      return <Trans i18nKey="Enum_CbiWasteContainerFrequencyPeriodEnum-MONTHLY" />;
    case cbi_waste_container_frequency_period_enum.ONCE:
      return <Trans i18nKey="Enum_CbiWasteContainerFrequencyPeriodEnum-ONCE" />;
    case cbi_waste_container_frequency_period_enum.QUARTERLY:
      return <Trans i18nKey="Enum_CbiWasteContainerFrequencyPeriodEnum-QUARTERLY" />;
    case cbi_waste_container_frequency_period_enum.WEEKLY:
      return <Trans i18nKey="Enum_CbiWasteContainerFrequencyPeriodEnum-WEEKLY" />;
    case cbi_waste_container_frequency_period_enum.YEARLY:
      return <Trans i18nKey="Enum_CbiWasteContainerFrequencyPeriodEnum-YEARLY" />;
  }
};

export const translateCbiWasteContainerFrequencyPeriodEnum_dynamic = (
  enumValue: cbi_waste_container_frequency_period_enum,
) => {
  const t = getI18n().t;
  switch (enumValue) {
    case cbi_waste_container_frequency_period_enum.BIWEEKLY:
      return t('Enum_CbiWasteContainerFrequencyPeriodEnum-BIWEEKLY');
    case cbi_waste_container_frequency_period_enum.DAILY:
      return t('Enum_CbiWasteContainerFrequencyPeriodEnum-DAILY');
    case cbi_waste_container_frequency_period_enum.MONTHLY:
      return t('Enum_CbiWasteContainerFrequencyPeriodEnum-MONTHLY');
    case cbi_waste_container_frequency_period_enum.ONCE:
      return t('Enum_CbiWasteContainerFrequencyPeriodEnum-ONCE');
    case cbi_waste_container_frequency_period_enum.QUARTERLY:
      return t('Enum_CbiWasteContainerFrequencyPeriodEnum-QUARTERLY');
    case cbi_waste_container_frequency_period_enum.WEEKLY:
      return t('Enum_CbiWasteContainerFrequencyPeriodEnum-WEEKLY');
    case cbi_waste_container_frequency_period_enum.YEARLY:
      return t('Enum_CbiWasteContainerFrequencyPeriodEnum-YEARLY');
  }
};
